/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RedeemedFreeProcessing": {
                    "fields": {
                      "totalRedeemedBalance": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "remainingBalance": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RedeemedFreeProcessing) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Information around redeemed free processing
 * --
 *
 * SOURCE RedeemedFreeProcessing @ squareup/corporate_card/resources/rewards/redeemed_free_processing.proto at 10:1
 */
export const RedeemedFreeProcessing = $root.lookupType('squareup.corporate_card.resources.rewards.RedeemedFreeProcessing');
fixType(RedeemedFreeProcessing);
Builder.createAndAttachToType(RedeemedFreeProcessing);